import { ControlValueAccessor } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

export class ValueAccessorBase<T> implements ControlValueAccessor {
  protected innerValue: T;

  protected valueObserver = new BehaviorSubject<T>(this.value);

  public changed = (value: T): void => {};
  public touched = (_: any): void => {};

  get value(): T {
    return this.innerValue;
  }

  set value(value: T) {
    if (this.innerValue !== value) {
      this.innerValue = value;
      this.changed(value);
      this.valueObserver.next(value);
    }
  }

  touch() {
    this.touched(null);
  }

  writeValue(value: T) {
    this.innerValue = value;
    this.valueObserver.next(value);
  }

  registerOnChange(fn: (value: T) => void) {
    this.changed = fn;
  }

  registerOnTouched(fn: () => void) {
    this.touched = fn;
  }
}
